module.exports = __webpack_public_path__ + "static/grow_logo-4db0fc1c4d7360c56fd2ecf5adb3f691.png";